export const SOLUTION = {
  JOBFLEX: 'JOBFLEX',
  JOBDA: 'JOBDA',
} as const;

export const SOLUTION_LIST = Object.keys(SOLUTION) as SolutionType[];
export type SolutionType = (typeof SOLUTION)[keyof typeof SOLUTION];
